// Utilitaire pour gérer les URLs d'images
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1').replace('/api/v1', '');

/**
 * Génère l'URL complète pour une image uploadée
 * @param {string} imagePath - Le chemin de l'image stocké en base
 * @param {string} fallback - Image de fallback si l'image n'existe pas
 * @returns {string} URL complète de l'image
 */
export const getImageUrl = (imagePath, fallback = '/images/placeholder.jpg') => {
  if (!imagePath) {
    return fallback;
  }

  // Si c'est déjà une URL complète (http/https), la retourner telle quelle
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Si c'est un chemin local (commence par /), le retourner tel quel
  if (imagePath.startsWith('/')) {
    return imagePath;
  }

  // Sinon, c'est un fichier uploadé, construire l'URL complète
  return `${API_BASE_URL}/storage/${imagePath}`;
};

/**
 * Génère l'URL pour la première image d'un array d'images
 * @param {Array|string} images - Array d'images ou string JSON
 * @param {string} fallback - Image de fallback
 * @returns {string} URL de la première image
 */
export const getFirstImageUrl = (images, fallback = '/images/placeholder.jpg') => {
  if (!images) {
    return fallback;
  }

  // Si c'est un array
  if (Array.isArray(images) && images.length > 0) {
    return getImageUrl(images[0], fallback);
  }

  // Si c'est une string, essayer de la parser comme JSON
  if (typeof images === 'string') {
    try {
      const parsedImages = JSON.parse(images);
      if (Array.isArray(parsedImages) && parsedImages.length > 0) {
        return getImageUrl(parsedImages[0], fallback);
      }
    } catch (e) {
      // Si ce n'est pas du JSON, traiter comme une image simple
      return getImageUrl(images, fallback);
    }
  }

  return fallback;
};

/**
 * Gère les erreurs de chargement d'image
 * @param {Event} e - Event de l'erreur
 * @param {string} fallback - Image de fallback
 */
export const handleImageError = (e, fallback = '/images/placeholder.jpg') => {
  e.target.src = fallback;
};